import { Modal, ModalProps } from "react-bootstrap";
import { useEffect } from "react";
import Caution from "./../assets/img/caution.png";

interface QrSessionExpiredModalProps extends ModalProps {
  onHide: () => void;
  title?: string;
}

const QrSessionExpiredModal = ({ onHide, title, ...props }: QrSessionExpiredModalProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onHide();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onHide]);

  return (
    <Modal
      {...props}
      onHide={onHide}
      backdrop="static"
      className="qrSessionExpiredModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div className="otpModalBody py-4">
          <div>
            <img src={Caution} alt="Caution" />
          </div>
          <div className="header" style={{ fontSize: '27px' }}>QR session expired</div>
          <div className="description" style={{ fontSize: '18px' }}>
            {title || ""}
          </div>
          {/* <button type="button" className="btnCancelMenu mt-4" onClick={onHide}>
            Go back
          </button> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default QrSessionExpiredModal;
